import React from 'react'
import Container from '../components/shared/container'
import Slide from '../components/slide'

function SlidePage() {
  return (
    <Container>
      <Slide />
    </Container>
  )
}

export default SlidePage
